module.exports = "js/webpack/5034704a76cd55c1cbcbc58ea6bf523f.gif";